import { render } from "./ExpiryManagement.vue?vue&type=template&id=22d8fae5"
import script from "./ExpiryManagement.vue?vue&type=script&lang=js"
export * from "./ExpiryManagement.vue?vue&type=script&lang=js"
script.render = render

export default script